<div class="nav-bar" [style.bottom.px]="layout.navbarBottomOffset()">
	<div class="nav-bar-content">
		@for(menuItem of navbarItems(); track $index;){
		@if(menuItem.routerLink){
		<a [routerLink]="menuItem.routerLink" [class.active]="isActive(menuItem.routerLink)" (click)="logActivity()">
			<i class="{{menuItem.iconStyle}} {{menuItem.icon}} {{menuItem.iconColor}}"></i>
			<span>{{menuItem.label}}</span><strong></strong>
		</a>
		}
		@if(menuItem.url){
		<a [href]="menuItem.url" [target]="menuItem.label" (click)="logActivity()">
			<i class="{{menuItem.iconStyle}} {{menuItem.icon}} {{menuItem.iconColor}}"></i>
			<span>{{menuItem.label}}</span><strong></strong>
		</a>
		}
		}
	</div>
</div>